import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import ErrorIcon from '@material-ui/icons/Error';
import Toolbar from '@material-ui/core/Toolbar';
import { Grid, Typography, Button, CircularProgress } from '@material-ui/core/';
import ButtonMUI from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ExcelIcon } from '../../../core/themes/icons/ExcelIcon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import FileInput from '../../../core/components/forked/input/FileInput';
import FileField from '../../../core/components/forked/field/FileField';
import { FormDataConsumer, refreshView, Loading } from 'react-admin';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import InvestorApi from '../../../core/apis/InvestorApi';
import { useNotify } from 'ra-core';
import { getIcError } from '../../../core/providers/utils';
import { saveAs } from 'file-saver';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';
import WireInstructionsImportFromExcel from '../wireinstructions/WireInstructionsImportFromExcel';

const styles = {
  avatar: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    height: '36px',
    width: '36px',
    color: '#757575'
  },
  errorIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'red'
  },
  warningIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'orange'
  },
  toolbarStyle: {
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E5E5',
    minHeight: '54px',
    paddingTop: '0',
    paddingBottom: '0'
  },
  firstButtonStyle: {
    minHeight: '30px',
    padding: '5px 10px'
  },
  buttonStyle: {
    minHeight: '30px',
    padding: '5px 10px',
    marginRight: '10px'
  },
  root: {
    flexGrow: 1
  },
  barTitle: {
    flexGrow: 1,
    paddingLeft: '8px'
  },
  label: {
    paddingRight: '0px'
  },
  horisontalRule: {
    height: '1px',
    backgroundColor: '#E0E0E0',
    border: 'none'
  },
  ButtonMUISpan: {
    paddingLeft: '4px'
  },
  excelIcon: {
    verticalAlign: 'middle',
    paddingRight: '10px'
  },
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  leftWrapper: {
    flexGrow: 1
  },
  validateButton: {
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  validateButtonText: {
    color: 'grey'
  },
  validationColumn: {
    color: 'red'
  },
  validationColumnWarning: {
    color: 'orange'
  },
  noRows: {
    color: 'red'
  },
  tabsStyle: {
    color: 'black',
    background: 'transparent'
  },
  tableWrapper: {
    maxHeight: '70vh',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  table: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 364px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  }
};

const AvatarImage = withStyles(styles)(({ classes, icon }) => {
  return <Avatar className={classes.avatar}>{icon}</Avatar>;
});

const ExcelIconImage = withStyles(styles)(({ classes, icon }) => {
  return <ExcelIcon className={classes.excelIcon}>{icon}</ExcelIcon>;
});

const ErrorImage = withStyles(styles)(({ classes, icon }) => {
  return <ErrorIcon className={classes.errorIcon}>{icon}</ErrorIcon>;
});
const WarningImage = withStyles(styles)(({ classes, icon }) => {
  return <ErrorIcon className={classes.warningIcon}>{icon}</ErrorIcon>;
});
const StyledFileInput = withStyles({
  dropZone: {
    background: '#ffffff',
    border: '1px dashed #E0E0E0'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  }
})(FileInput);

const ExcelInvestorImportTitleBarWithDropbox = withStyles(styles)(
  ({
    classes,
    type,
    title,
    createUrl,
    secondTitle,
    secondCreateUrl,
    icon,
    hasCreatePermission,
    hasExportInvestorsExcelPermission,
    hasImportInvestorExcelPermission,
    hasImportWireInstructionExcelPermission,
    hasCreateWireInstructionPermission,
    filters,
    selectedIds,
    ...rest
  }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [importModelViewToggle, setsViewOfImport] = useState(false);
    const [validateButtonVisibile, setValidateButtonVisibility] = useState(
      false
    );
    const [submitting, setSubmitting] = useState(false);
    const [disableImportButton, setImportButtonDisabled] = useState(true);
    const [loaderVisible, setLoaderVisible] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [showNoDataInExcelError, setShowNoDataInExcelError] = useState(false);
    const [isFileFieldDisabled, setIsFileFieldDisabled] = useState(false);
    const [value, setValue] = useState('1');
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState(-1);
    const [response, setResponse] = useState('');
    const [responseTab2, setResponseTab2] = useState('');
    const [responseTab3, setResponseTab3] = useState('');
    const [responseTab4, setResponseTab4] = useState('');
    const notify = useNotify();
    const notifyServerError = useNotifyServerError();
    const [tab1ContainsErrors, setTab1ContainsErrors] = useState(false);
    const [tab1ContainsWarning, setTab1ContainsWarning] = useState(false);
    const [tab2ContainsErrors, setTab2ContainsErrors] = useState(false);
    const [tab3ContainsErrors, setTab3ContainsErrors] = useState(false);
    const [tab4ContainsErrors, setTab4ContainsErrors] = useState(false);
    const [tab4ContainsWarning, setTab4ContainsWarning] = useState(false);
    const [excelPayload, setExcelPayload] = useState(null);
    const [downloadingTemplate, setDownloadingTemplate] = useState(false);

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleImportClick = () => {
      setAnchorEl(null);
      setsViewOfImport(true);
    };

    const handleCloseImportClick = () => {
      setAnchorEl(null);
      cleanUpData();
      setsViewOfImport(false);
    };

    const columnDirectionSort = (sortColumnName, isDesc) => {
      return function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowIndex') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return x < y ? -1 : x > y ? 1 : 0;
        } else {
          return x < y ? 1 : x > y ? -1 : 0;
        }
      };
    };

    const handleRequestSort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowIndex';
          break;
        case 1:
          sortColumnName = 'investorId';
          break;
        case 2:
          sortColumnName = 'investorName';
          break;
        case 3:
          sortColumnName = 'aka';
          break;
        case 4:
          sortColumnName = 'taxId';
          break;
        case 5:
          sortColumnName = 'status';
          break;
        case 6:
          sortColumnName = 'addressLine1';
          break;
        case 7:
          sortColumnName = 'addressLine2';
          break;
        case 8:
          sortColumnName = 'addressLine3';
          break;
        case 9:
          sortColumnName = 'country';
          break;
        case 10:
          sortColumnName = 'phoneNumber';
          break;
        case 11:
          sortColumnName = 'stateProvince';
          break;
        case 12:
          sortColumnName = 'zipPostalCode';
          break;
        case 13:
          sortColumnName = 'city';
          break;
        case 14:
          sortColumnName = 'faxNumber';
          break;
        case 15:
          sortColumnName = 'matchingFieldTaxId';
          break;
        case 16:
          sortColumnName = 'matchingFieldAkaInvestorName';
          break;
        case 17:
          sortColumnName = 'matchingFieldAkaInvestorId';
          break;
        case 18:
          sortColumnName = 'matchingFieldCrossReference';
          break;
        case 19:
          sortColumnName = 'matchingFieldAlternateTaxId';
          break;
        case 20:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowIndex';
      }

      var sortedTableData = response.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const handleRequestTab2Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowIndex';
          break;
        case 1:
          sortColumnName = 'investorId';
          break;
        case 2:
          sortColumnName = 'fundId';
          break;
        case 3:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab2.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const handleRequestTab3Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowIndex';
          break;
        case 1:
          sortColumnName = 'investorId';
          break;
        case 2:
          sortColumnName = 'fundId';
          break;
        case 3:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab3.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const handleRequestTab4Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowIndex';
          break;
        case 1:
          sortColumnName = 'investorId';
          break;
        case 2:
          sortColumnName = 'fundId';
          break;
        case 3:
          sortColumnName = 'investorFreezeStartDate';
          break;
        case 4:
          sortColumnName = 'investorFreezeEndDate';
          break;
        case 5:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowNum';
      }

      var sortedTableData = responseTab4.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const cleanUpData = value => {
      setTab1ContainsErrors(false);
      setTab1ContainsWarning(false);
      setTab2ContainsErrors(false);
      setTab3ContainsErrors(false);
      setTab4ContainsErrors(false);
      setTab4ContainsWarning(false);
      setShowGrid(false);
      setImportButtonDisabled(true);
      if (value) {
        setValidateButtonVisibility(true);
      } else {
        setValidateButtonVisibility(false);
      }
    };

    const handleClickValidation = async values => {
      var payload = new FormData();
      if (values.file) {
        payload.append('excelFile', values.file.rawFile, values.file.title);
      }

      setValidateButtonVisibility(false);
      setImportButtonDisabled(true);
      setLoaderVisible(true);
      setIsFileFieldDisabled(true);

      InvestorApi.validateImportFromExcel(payload)
        .then(responseData => {
          var arrayData = responseData['validatedInvestorDetails'];
          setResponse(arrayData);

          var arrayDataTab2 = responseData['validatedAddingInvestorFundImport'];
          setResponseTab2(arrayDataTab2);

          var arrayDataTab3 =
            responseData['validatedDeletingInvestorFundImport'];
          setResponseTab3(arrayDataTab3);

          var arrayDataTab4 = responseData['validatedInvestorFreezeImport'];
          setResponseTab4(arrayDataTab4);

          const validationErrors = arrayData
            .slice(0)
            .filter(r => r.validationError !== '');
          setTab1ContainsErrors(validationErrors.length > 0);

          const validationWarningTab1 = arrayData
            .slice(0)
            .filter(r => r.warningMessage !== '');

          const validationErrorsTab2 = arrayDataTab2
            .slice(0)
            .filter(r => r.validationError !== '');
          setTab2ContainsErrors(validationErrorsTab2.length > 0);

          const validationErrorsTab3 = arrayDataTab3
            .slice(0)
            .filter(r => r.validationError !== '');
          setTab3ContainsErrors(validationErrorsTab3.length > 0);

          const validationErrorsTab4 = arrayDataTab4
            .slice(0)
            .filter(r => r.validationError !== '');
          setTab4ContainsErrors(validationErrorsTab4.length > 0);

          const validationWarningTab4 = arrayDataTab4
            .slice(0)
            .filter(r => r.validationWarning !== '');

          if (
            arrayData.length > 0 ||
            arrayDataTab2.length > 0 ||
            arrayDataTab3.length > 0 ||
            arrayDataTab4.length > 0
          ) {
            var errors = false;
            if (
              arrayData.length > 0 &&
              validationErrors &&
              validationErrors.length > 0
            ) {
              errors = true;
            } else if (
              arrayData.length &&
              validationWarningTab1 &&
              validationWarningTab1.length > 0
            ) {
              setTab1ContainsWarning(true);
            }
            if (
              arrayDataTab2.length > 0 &&
              validationErrorsTab2 &&
              validationErrorsTab2.length > 0
            ) {
              errors = true;
            }
            if (
              arrayDataTab3.length > 0 &&
              validationErrorsTab3 &&
              validationErrorsTab3.length > 0
            ) {
              errors = true;
            }
            if (
              arrayDataTab4.length > 0 &&
              validationErrorsTab4 &&
              validationErrorsTab4.length > 0
            ) {
              errors = true;
            } else if (
              arrayDataTab4.length &&
              validationWarningTab4 &&
              validationWarningTab4.length > 0
            ) {
              setTab4ContainsWarning(true);
            }
            setImportButtonDisabled(errors);
          } else {
            setImportButtonDisabled(false);
            setShowNoDataInExcelError(true);
          }

          setLoaderVisible(false);
          setIsFileFieldDisabled(false);
          setShowGrid(true);
          setExcelPayload(payload);
        })
        .catch(e => {
          setExcelPayload(null);
          setLoaderVisible(false);
          setIsFileFieldDisabled(false);
          notify(getIcError(e), { type: 'error' });
        });
    };

    const handleImportInvestorsClick = () => {
      setImportButtonDisabled(true);
      if (!excelPayload) {
        return;
      }
      setLoaderVisible(true);
      setShowGrid(false);
      InvestorApi.importInvestorsFromExcel(excelPayload)
        .then(() => {
          notify('ra.notification.custom_updated_message');
        })
        .catch(e => {
          setLoaderVisible(false);
          notifyServerError(e);
        })
        .finally(() => {
          setLoaderVisible(false);
          setsViewOfImport(false);
          handleCloseImportClick();
          refreshView();
        });
    };

    const handleTemplateDownload = () => {
      setDownloadingTemplate(true);
      InvestorApi.downloadInvestorImportTemplate()
        .then(resp => {
          const fileName = 'Investor Import Template.xlsx';
          saveAs(resp, fileName);
        })
        .catch(e => {
          notifyServerError(e);
        })
        .finally(() => {
          setDownloadingTemplate(false);
        });
    };

    const handleExportClick = filters => {
      setSubmitting(true);
      InvestorApi.exportInvestorsExcel(
        filters.id,
        filters.name,
        filters.status,
        filters.investorTagId,
        filters.fundFamilyId,
        selectedIds
      )
        .then(resp => {
          const fileName = 'Investors Export.xlsx';
          saveAs(resp, fileName);
          setSubmitting(false);
        })
        .catch(e => {
          notifyServerError(e);
          setSubmitting(false);
        });
    };

    return (
      <Toolbar className={classes.toolbarStyle}>
        <AvatarImage icon={icon} />
        <Typography
          style={{ fontSize: '20px', lineHeight: '28px' }}
          color="textPrimary"
          className={classes.barTitle}
        >
          {type}
        </Typography>
        {(hasImportInvestorExcelPermission ||
          hasExportInvestorsExcelPermission) && (
          <div>
            <WireInstructionsImportFromExcel
              hasImportWireInstructionExcelPermission={
                hasImportWireInstructionExcelPermission &&
                hasCreateWireInstructionPermission
              }
              hasExportWireInstructionExcelPermission={false}
            />
            <ButtonMUI
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <div className={classes.WrapperClass}>
                <ExcelIconImage />
                <span className={classes.ButtonMUISpan}>
                  Import/Export Investors
                </span>
              </div>
            </ButtonMUI>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {hasImportInvestorExcelPermission && (
                <MenuItem onClick={handleImportClick}>
                  Import Investors from Excel
                </MenuItem>
              )}
              {hasExportInvestorsExcelPermission && (
                <MenuItem
                  onClick={() => handleExportClick(filters)}
                  disabled={submitting}
                >
                  {submitting && (
                    <span className={classes.circularProgress}>
                      <CircularProgress size={'15px'} />
                    </span>
                  )}
                  Export Investors to Excel
                </MenuItem>
              )}
              {hasImportInvestorExcelPermission && (
                <div>
                  <hr className={classes.horisontalRule} />
                  <MenuItem
                    onClick={handleTemplateDownload}
                    disabled={downloadingTemplate}
                  >
                    {downloadingTemplate && (
                      <span className={classes.circularProgress}>
                        <CircularProgress size={'15px'} />
                      </span>
                    )}
                    Download Template
                  </MenuItem>
                </div>
              )}
            </Menu>
          </div>
        )}

        {hasCreatePermission && title && (
          <Button
            className={classes.firstButtonStyle}
            variant="contained"
            color="primary"
            href={createUrl}
          >
            {title}
          </Button>
        )}

        <Dialog
          open={importModelViewToggle}
          aria-label="Import Investors from Excel"
          maxWidth={false}
          onClose={(event, reason) => {
            if (reason === 'backdropClick') return null;
            if (reason === 'escapeKeyDown') return handleCloseImportClick();
          }}
          classes={{
            paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
          }}
        >
          <DialogTitleWithCloseButton onClose={handleCloseImportClick}>
            Import Investors from Excel
          </DialogTitleWithCloseButton>

          <DialogContent>
            <div>
              <CustomSimpleForm
                toolbar={null}
                margin="normal"
                variant="standard"
              >
                <FormDataConsumer>
                  {({ formData, ...rest }) => (
                    <Grid>
                      {!isFileFieldDisabled && (
                        <StyledFileInput
                          source="file"
                          label="Import File"
                          accept={
                            'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                          }
                          placeholder="Drag and drop File Here or Upload"
                          variant="standard"
                          onChange={value => cleanUpData(value)}
                        >
                          <FileField
                            source="src"
                            title="title"
                            size="size"
                            type="type"
                          />
                        </StyledFileInput>
                      )}
                      {loaderVisible && <Loading />}

                      {validateButtonVisibile && (
                        <div className={classes.validateButton}>
                          <p className={classes.validateButtonText}>
                            No Data To Display
                            <br />
                            Click 'Validate' to parse and display Excel Data
                          </p>
                          <Button
                            onClick={() => handleClickValidation(formData)}
                            color="primary"
                            variant="contained"
                          >
                            Validate
                          </Button>
                        </div>
                      )}

                      {showGrid && (
                        <div className={classes.root}>
                          <TabContext value={value}>
                            <AppBar
                              position="static"
                              className={classes.tabsStyle}
                            >
                              <TabList
                                onChange={handleChange}
                                aria-label="simple tabs example"
                              >
                                <Tab
                                  label="Add or Modify Investor"
                                  value="1"
                                  selectionFollowsFocus
                                  component={() => {
                                    return (
                                      <Button onClick={() => setValue('1')}>
                                        {tab1ContainsErrors && <ErrorImage />}
                                        {tab1ContainsWarning && (
                                          <WarningImage />
                                        )}
                                        Add or Modify Investor
                                      </Button>
                                    );
                                  }}
                                />
                                <Tab
                                  label="Add or Modify FundInv Relations"
                                  value="2"
                                  component={() => {
                                    return (
                                      <Button onClick={() => setValue('2')}>
                                        {tab2ContainsErrors && <ErrorImage />}
                                        Add or Modify FundInv Relations
                                      </Button>
                                    );
                                  }}
                                />
                                <Tab
                                  label="Remove FundInv Relations"
                                  value="3"
                                  component={() => {
                                    return (
                                      <Button onClick={() => setValue('3')}>
                                        {tab3ContainsErrors && <ErrorImage />}
                                        Remove FundInv Relations
                                      </Button>
                                    );
                                  }}
                                />
                                <Tab
                                  label="Add or Modify Investor Freeze Start And End Date"
                                  value="4"
                                  component={() => {
                                    return (
                                      <Button onClick={() => setValue('4')}>
                                        {tab4ContainsErrors && <ErrorImage />}
                                        {tab4ContainsWarning && (
                                          <WarningImage />
                                        )}
                                        Add or Modify Investor Freeze Start And
                                        End Date
                                      </Button>
                                    );
                                  }}
                                />
                              </TabList>
                            </AppBar>
                            <TabPanel value="1" selected={true}>
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Investor ID' },
                                        { id: 'Investor Name' },
                                        { id: 'A.K.A' },
                                        { id: 'Tax ID' },
                                        { id: 'Status' },
                                        { id: 'Address Line 1' },
                                        { id: 'Address Line 2' },
                                        { id: 'Address Line 3' },
                                        { id: 'Country' },
                                        { id: 'Phone Number' },
                                        { id: 'State/Province' },
                                        { id: 'Zip/Postal Code' },
                                        { id: 'City' },
                                        { id: 'Fax Number' },
                                        { id: 'Matching Field - Tax ID' },
                                        {
                                          id:
                                            'Matching Field - A.K.A Investor Name'
                                        },
                                        {
                                          id: 'Matching Field - AKA Investor ID'
                                        },
                                        {
                                          id: 'Matching Field - Cross Reference'
                                        },
                                        {
                                          id:
                                            'Matching Field - Alternative Tax ID'
                                        },
                                        {
                                          id:
                                            'Validation Error / Warning Message'
                                        }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestSort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {response.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowIndex}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>
                                            {item.investorName}
                                          </TableCell>
                                          <TableCell>{item.aka}</TableCell>
                                          <TableCell>{item.taxId}</TableCell>
                                          <TableCell>{item.status}</TableCell>
                                          <TableCell>
                                            {item.addressLine1}
                                          </TableCell>
                                          <TableCell>
                                            {item.addressLine2}
                                          </TableCell>
                                          <TableCell>
                                            {item.addressLine3}
                                          </TableCell>
                                          <TableCell>{item.country}</TableCell>
                                          <TableCell>
                                            {item.phoneNumber}
                                          </TableCell>
                                          <TableCell>
                                            {item.stateProvince}
                                          </TableCell>
                                          <TableCell>
                                            {item.zipPostalCode}
                                          </TableCell>
                                          <TableCell>{item.city}</TableCell>
                                          <TableCell>
                                            {item.faxNumber}
                                          </TableCell>
                                          <TableCell>
                                            {item.matchingFieldTaxId}
                                          </TableCell>
                                          <TableCell>
                                            {item.matchingFieldAkaInvestorName}
                                          </TableCell>
                                          <TableCell>
                                            {item.matchingFieldAkaInvestorId}
                                          </TableCell>
                                          <TableCell>
                                            {item.matchingFieldCrossReference}
                                          </TableCell>
                                          <TableCell>
                                            {item.matchingFieldAlternateTaxId}
                                          </TableCell>
                                          <TableCell
                                            className={
                                              tab1ContainsErrors
                                                ? classes.validationColumn
                                                : classes.validationColumnWarning
                                            }
                                          >
                                            {tab1ContainsErrors
                                              ? item.validationError
                                              : item.warningMessage}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="2">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Fund ID' },
                                        { id: 'Investor ID' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab2Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab2.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowIndex}</TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="3">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Fund ID' },
                                        { id: 'Investor ID' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab3Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab3.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowIndex}</TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="4">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Fund ID' },
                                        { id: 'Investor ID' },
                                        { id: 'Investor Freeze Start Date' },
                                        { id: 'Investor Freeze End Date' },
                                        {
                                          id:
                                            'Validation Error / Warning Message'
                                        }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab4Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab4.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowIndex}</TableCell>
                                          <TableCell>{item.fundId}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>
                                            {item.investorFreezeStartDate}
                                          </TableCell>
                                          <TableCell>
                                            {item.investorFreezeEndDate}
                                          </TableCell>
                                          <TableCell
                                            className={
                                              tab4ContainsErrors
                                                ? classes.validationColumn
                                                : classes.validationColumnWarning
                                            }
                                          >
                                            {tab4ContainsErrors
                                              ? item.validationError
                                              : item.validationWarning}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                          </TabContext>
                        </div>
                      )}
                    </Grid>
                  )}
                </FormDataConsumer>
              </CustomSimpleForm>
            </div>
          </DialogContent>
          <DialogActions style={{ borderTop: `1px solid rgba(0, 0, 0, 0.12)` }}>
            <div className={classes.leftWrapper}>
              <Button
                onClick={handleCloseImportClick}
                color="primary"
                variant="outlined"
                className={classes.button}
              >
                Close
              </Button>
            </div>
            <Button
              onClick={handleImportInvestorsClick}
              color="primary"
              variant="contained"
              className={classes.button}
              disabled={disableImportButton}
            >
              Import
            </Button>
          </DialogActions>
        </Dialog>
      </Toolbar>
    );
  }
);

export default ExcelInvestorImportTitleBarWithDropbox;
